export default {
  'en': {
    'TAG_NAME_LABEL': 'Name',
    'TAG_NAME_TT': 'The name of the tag',
    'TAG_NAME_PLACEHOLDER': 'Enter Tag Name',
    'TAG_VALUE_LABEL': 'Value',
    'TAG_VALUE_TT': 'The value of the tag <br/> (max 512 characters)',
    'TAG_VALUE_PLACEHOLDER': 'Enter Value',
    'ADD_ANNOTATION_BTN': 'Annotate'
  }
};